// Request mismatch indicator for search query/filters

import { getLastFulltextSearchState } from './state.js';

/**
 * Update request mismatch indicator when query or filters change
 * @param {string} inputQuery - Current input query
 */
export function updateFulltextRequestMismatchIndicator(inputQuery) {
    try {
        const $req = $('#nav-full-text .search-request-text');
        if (!$req.length) return;
        const $text = $req.find('.fulltext-request-text');
        const reqText = ($text.text() || '').toString().trim();
        const current = (inputQuery || '').toString().trim();
        
        // Get current filter state - prefer filterController state over URL (URL may lag behind)
        let currentFilters = {
            query: current,
            cat: '',
            dateFrom: '',
            dateTo: ''
        };
        
        // Try to get filters from filterController first (current state, not URL)
        let gotFromController = false;
        if (window.filterController) {
            try {
                const activeFilters = window.filterController.getActiveFilters ? window.filterController.getActiveFilters() : null;
                const selectedCategories = window.filterController.getSelectedCategories ? window.filterController.getSelectedCategories() : null;
                
                if (activeFilters) {
                    currentFilters.dateFrom = (activeFilters.dateFrom || '').toString().trim();
                    currentFilters.dateTo = (activeFilters.dateTo || '').toString().trim();
                    gotFromController = true;
                }
                
                // Serialize categories to URL format (same as in filter-controller.url.js)
                if (selectedCategories && Object.keys(selectedCategories).length > 0) {
                    const allValues = [];
                    for (const [group, values] of Object.entries(selectedCategories)) {
                        if (Array.isArray(values) && values.length > 0) {
                            allValues.push(...values);
                        }
                    }
                    if (allValues.length > 0) {
                        currentFilters.cat = allValues.join('-');
                    }
                    gotFromController = true;
                }
            } catch(_) {}
        }
        
        // Fallback to URL if filterController not available or didn't provide data
        if (!gotFromController) {
            const urlParams = new URLSearchParams(window.location.search);
            currentFilters.cat = urlParams.get('cat') || '';
            currentFilters.dateFrom = urlParams.get('dateFrom') || '';
            currentFilters.dateTo = urlParams.get('dateTo') || '';
        }
        
        // Compare with last search state
        const lastFulltextSearchState = getLastFulltextSearchState();
        const queryChanged = !!reqText && !!current && (reqText !== current);
        const filtersChanged = lastFulltextSearchState && (
            lastFulltextSearchState.cat !== currentFilters.cat ||
            lastFulltextSearchState.dateFrom !== currentFilters.dateFrom ||
            lastFulltextSearchState.dateTo !== currentFilters.dateTo
        );
        
        const changed = queryChanged || filtersChanged;
        const badge = $('#nav-full-text-card-tab .fulltext-request-refresh-badge');
        
        if (changed) {
            $text.addClass('fulltext-request-changed');
            if (badge.length) badge.removeClass('d-none');
        } else {
            $text.removeClass('fulltext-request-changed');
            if (badge.length) badge.addClass('d-none');
        }
    } catch(_) {}
}

